export default [
    {
        path: "/alarm",
        name: "alarm",
        component: () => import("./List"),
        meta: {
            permiss: ['ALARM_SHOW', 'ALARM_SHOW'],
            title: "告警管理"
        }
    },
    {
        path: "/alarm/alarmDetail/:id/:deviceId",
        name: "alarmDetail",
        component: () => import("./Detail"),
        meta: {
            permiss: ['ALARM_SHOW'],
            title: "警情详情"
        }
    },
    {
        path: "/alarm/alarmDeal/:id",
        name: "alarmDeal",
        component: () => import("./Submit"),
        meta: {
            permiss: ['DEVICE_HANDLE_ALARM'],
            title: "警情处理"
        }
    },
]